import script from "./DiagnosticReportDetails2.vue?vue&type=script&lang=ts&setup=true"
export * from "./DiagnosticReportDetails2.vue?vue&type=script&lang=ts&setup=true"

import "./DiagnosticReportDetails2.vue?vue&type=style&index=0&id=255d0dba&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255d0dba"]])

export default __exports__